import { useTranslation } from 'react-i18next';

const features = [
  { icon: 'ri-table-line', titleKey: 'feature.spreadsheet.title', descKey: 'feature.spreadsheet.desc' },
  { icon: 'ri-camera-line', titleKey: 'feature.qc.title', descKey: 'feature.qc.desc' },
  { icon: 'ri-truck-line', titleKey: 'feature.shipping.title', descKey: 'feature.shipping.desc' },
  { icon: 'ri-star-line', titleKey: 'feature.reviews.title', descKey: 'feature.reviews.desc' },
  { icon: 'ri-shield-check-line', titleKey: 'feature.safety.title', descKey: 'feature.safety.desc' },
  { icon: 'ri-scales-3-line', titleKey: 'feature.comparisons.title', descKey: 'feature.comparisons.desc' },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section id="features" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-3xl">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            {t('about.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('about.subtitle')}</p>
          <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            {t('about.paragraph1')}
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            {t('about.paragraph2')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.titleKey}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <span className="flex w-11 h-11 md:w-12 md:h-12 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {t(feature.titleKey)}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t(feature.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}